import {call, put, takeEvery, takeLatest} from 'redux-saga/effects'
import isEmpty from 'lodash/isEmpty'

import * as addressValidationActions from '../actions/addressValidation'
import * as api from '../api/addressValidation'
import * as userInteractionsActions from '../actions/userInteractions'
import {isBadResponse} from '../api/statusCodes'

/**
 * Handles the API call to our server for validating an address
 */
export function* validateAddressWorker({payload}) {
  yield put(addressValidationActions.validateAddressPending())
  try {
    const {json, status} = yield call(api.validateAddress, payload)
    if (isBadResponse(status)) {
      throw new Error('Unable to validate address')
    }
    yield put(addressValidationActions.validateAddressSuccess({...json}))
  } catch (error) {
    yield put(addressValidationActions.validateAddressFailure(error))
  }
}

export function* validateAddressSaga() {
  yield takeLatest(addressValidationActions.VALIDATE_ADDRESS, validateAddressWorker)
}

/**
 * Open a modal for user input unless the address is valid and has no recommended updates
 */
export function* validateAddressSuccessWorker({payload: {isValid, recommendedUpdates}}) {
  if (isValid && isEmpty(recommendedUpdates)) {
    yield put(addressValidationActions.utilizeInputAddress({bypassedVerifiedAddress: false}))
    return
  }
  yield put(userInteractionsActions.openAddressValidationModal())
}

export function* validateAddressSuccessSaga() {
  yield takeLatest(addressValidationActions.VALIDATE_ADDRESS_SUCCESS, validateAddressSuccessWorker)
}

/**
 * Show a generic error if we receive a bad response code from the server
 */
export function* validateAddressFailureWorker() {
  yield call(window.alert, 'We encountered an error. Please try again.')
}

export function* validateAddressFailureSaga() {
  yield takeEvery(addressValidationActions.VALIDATE_ADDRESS_FAILURE, validateAddressFailureWorker)
}
